// extracted by mini-css-extract-plugin
module.exports = {"card":"CardGrey_card__1jU03"};